export default __webpack_public_path__ + "static/media/title_xl.5415718c.jpg";